import { isNullable } from '@ipfabric/utils';
import { makeSelectSnapshotInJobs } from 'containers/App/Header/JobManagement/selectors';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { T, always, cond, equals } from 'ramda';
import { PureComponent } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getElapsedTime } from '../helpers';
import { makeSelectContentSnapshot } from '../selectors';

class SnapshotLoadingBar extends PureComponent {
  static propTypes = {
    msg: PropTypes.object.isRequired,
    snapshot: ImmutablePropTypes.map.isRequired,
    snapshotInJobs: ImmutablePropTypes.map,
  };

  state = {
    elapsedTime: 0,
  };

  componentDidMount() {
    this.updateTimeElapsed();
    this.timer = setInterval(this.updateTimeElapsed.bind(this), 1000);
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  updateTimeElapsed = () => {
    const { snapshot, snapshotInJobs } = this.props;
    if (!snapshot || !snapshotInJobs) {
      return;
    }
    const tsStart = snapshotInJobs.get('startedAt');
    const seconds = Math.floor((snapshot.get('ts') - tsStart) / 1000);
    this.setState({ elapsedTime: seconds });
  };

  render() {
    const { msg, snapshot } = this.props;
    const actuallyLoadedDevices = snapshot.get('totalDevCount');
    const totalDevicesToLoad = snapshot.get('totalDevices');
    const { elapsedTime } = this.state;
    const pct = cond([
      [() => isNullable(actuallyLoadedDevices), always('0')],
      [equals(0), always('0')],
      [equals(totalDevicesToLoad), always('100')],
      [T, () => Math.floor((actuallyLoadedDevices / totalDevicesToLoad) * 100)],
    ])(actuallyLoadedDevices);
    return (
      <div className='row'>
        <div className='col-xs-12'>
          <div className='snapshots-loading-snapshot info-box'>
            <span className='info-box-icon'>
              <i className='fa fa-arrows-rotate fa-spin' />
            </span>
            <div className='info-box-content'>
              <span className='info-box-text'>
                {get(msg, 'snapshotLoadingBar.title', 'Loading snapshot')}
              </span>
              <span className='info-box-number'>
                {get(
                  msg,
                  'snapshotLoadingBar.devicesOfLoaded',
                  'Devices: {loaded} of {total} loaded',
                )
                  .replace(
                    '{loaded}',
                    (actuallyLoadedDevices || 0).toLocaleString(),
                  )
                  .replace(
                    '{total}',
                    (totalDevicesToLoad || 0).toLocaleString(),
                  )}
              </span>

              <div className='progress'>
                <div className='progress-bar' style={{ width: `${pct}%` }} />
              </div>
              <span className='progress-description'>
                {pct}
                {get(msg, 'snapshotLoadingBar.pctLoaded', '% loaded')}
                {elapsedTime > 0 && (
                  <span className='info-box-text pull-right'>
                    {getElapsedTime(elapsedTime)}
                  </span>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  snapshot: makeSelectContentSnapshot(),
  snapshotInJobs: makeSelectSnapshotInJobs(),
});

export default connect(mapStateToProps)(SnapshotLoadingBar);
